const IS_SERVER = typeof window === 'undefined'
export default function getUrl(path: string): string {
	const baseURL = IS_SERVER
		? import.meta.env.MODE == 'production'
			? 'https://yta.se'
			: 'https://staging.yta.se'
		: window.location.origin
	return new URL(path, baseURL).toString()
}
